<template>
  <DialogTemplateToolkit
    data-qa="change-winners-reason-dialog"
    :dialog="dialog"
    :first_btn="$t('Common.Save')"
    :loading="loading"
    :title="$t('Tenders.ProvideAReasonForChangingTheWinner')"
    @apply="openFunc"
    @close="close">
    <template #activator-btn>
      <sButton
        @click="open">
        {{ $t('Tenders.ConfirmSelection') }}
      </sButton>
    </template>
    <template #card-text>
      <div class="flex align-start">
        <sForm
          ref="changeWinnersForm"
          :disabled="loading"
          label-position="top"
          label-width="0px"
          :model="{text}"
          :rules="rules">
          <sFormItem
            prop="text">
            <sInput
              data-qa="change-winners-reason-textarea"
              max-length="4000"
              max-rows="15"
              rows="5"
              show-word-limit
              type="textarea"
              :value.sync="text"/>
          </sFormItem>
        </sForm>
        <sAlert
          class="ml-4"
          width="216px">
          {{ hint }}
        </sAlert>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
import { modalMixin, tenderMixin, validateRuls } from 'mixins'
const st_api = new SmarttenderApi()

export default {
  name: 'changeWinners',
  mixins: [modalMixin, tenderMixin, validateRuls],
  data() {
    return {
      dialog: false,
      text: '',
      loading: false,
      removed: [],
      selected: [],
      changedSelectedQuantity: [],
      rules: {
        text: [
          {
            type: 'string',
            trigger: 'change',
            max: 4000,
            message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 4000) })
          }
        ],
      }
    }
  },
  props: {
    tender: Object,
    changed_winners: Object
  },
  mounted() {
    this.rules.text.push(this.commentValidateRule[0])
  },
  computed: {
    hint() {
      return this.removed?.length ? this.$t('Tenders.TheStatedReasonWillBeForwardedToDisqualifiedWinners') : this.$t('Tenders.TheSpecifiedReasonWillBeSavedInTheHistoryOfTheTender')
    },
    succeeded_text() {
      return (this.removed?.length ? this.$t('Tenders.ReasonChangingWinnerIsDirectedToDisqualified')  : this.$t('Tenders.ReasonChangingWinnerSavedInHistory') )
      + '<br/> ' + this.$t('Tenders.YouCanSeeTheModifiedWinnersInTheProposalsTab')
    },
    only_quantity() {
      return !this.changed_winners?.bids?.length
    }
  },
  methods: {
    open() {
      if (!this.changed_winners?.bids?.length && !this.changed_winners?.quantity?.length) {
        this.$emit('submit')
      } else {
        this.changed_winners?.bids?.forEach(el => {
          if ( el.selectedBid ) {
            this.selected.push(el)
          } else {
            this.removed.push(el)
          }
        })
        this.changedSelectedQuantity = this.changed_winners?.quantity?.filter(element => element?.selectedBid && element?.changedSelectedQuantity) || []

        this.dialog = true
      }
    },
    close() {
      this.dialog = false
    },
    async openFunc() {
      this.loading = true
      let selected = []
      Object.values( this.$_.groupBy(this.selected?.concat(this.changedSelectedQuantity), 'id') ).forEach( items => {
        selected.push(items.find(el => el.changedSelectedQuantity) || items[0])
      })
      let model = {
        tenderId: this.tender?.tenderId,
        removeWinnerBidItemIds: this.removed?.map(el => el.id ),
        selectWinnerBidItemIds: selected?.map(el => ({
          bidItemId: el.id,
          quantity: el.selectedQuantity || el.quantity
        }) ),
        reason: this.text,
      }
      await st_api.changeTenderWinner(model)
        .then(async res => {
          this.$emit('submit', true)
          if (res?.success) {
            this.$Modal.info({
              closable: true,
              title: this.$t('Tenders.WinnerChangesSuccessfullyCompleted'),
              content: this.succeeded_text,
              okText: this.$t('Common.ThankYou'),
              width: 736
            })
          } else {
            throw this.$t('Errors.STHWrong')
          }

        }).finally(() => {
          this.loading = false
          this.dialog = false
        })
    }
  },
  components: {
    DialogTemplateToolkit,
  }
}
</script>
